<script>

  import {getContext, onDestroy} from "svelte";

  let { shopData } = getContext("SHOP")

  export let product;
  export let invoice;
  export let stripeData;

  const price = $shopData.price

  let showTotal = false;
  let taxAmount = 0
  let productTotal = price.unit_amount / 100;
  let discountAppliedAmt = $shopData.coupon ?  getDiscount() / 100 : 0
  let subTotal = 0;
  let total = 0;

  let priceItems = [];

  let originalPrice;
  let couponPrice;
  let showDiscountStar = false;

  $: invoice, updatePrice(invoice);

  if (stripeData){
    updatePrice(stripeData)
  }

  function getCouponDetails(){
    let data = ''
    if($shopData.coupon && $shopData.coupon.percent_off){
       data = $shopData.coupon.percent_off + "% off";
    }else if($shopData.coupon && $shopData.coupon.amount_off){
      data = $shopData.coupon.amount_off / 100 + " off"
    }
    return data;
  }

  function getDiscount(total=true){
    let unitPrice = price.unit_amount; // single unit price
    let discount = 0;
    if($shopData.coupon?.metadata?.type === 'admin_fee'){
      return total ? unitPrice : 0;
    }
    if($shopData.coupon && $shopData.coupon.percent_off){
      discount = (price.unit_amount * ($shopData.coupon.percent_off * 0.01))
    }else if($shopData.coupon && $shopData.coupon.amount_off){
      discount =  price.unit_amount - $shopData.coupon.amount_off
    }
    if(total){
      return unitPrice - discount;
    }
    return discount
  }

  function calculateItemPrice(lineItem){
    let defaultPrice = lineItem.amount;
    if(lineItem.discount_amounts && lineItem.discount_amounts.length) {
      let discounts = lineItem.discount_amounts.reduce((all, item)=>{
        all += item.amount
        return all;
      },0)
      defaultPrice -= discounts
    }
    return defaultPrice
  }


  export function updatePrice(data){
    if(!data) return;

    if(data.invoice){
      let invoice = data.invoice;
      let items = invoice.lines.data.reverse();
      let shippingItem;
      let adminFeeItem;
      items.forEach(lineItem => {
        let discounted = (lineItem.discount_amounts && lineItem.discount_amounts.length);
        if(discounted){
          showDiscountStar = true
        }
        if(lineItem.description.indexOf('Base') == -1){
          if (lineItem.description == 'Shipping') {
            shippingItem = lineItem
          } else if (lineItem.description && lineItem.description.toLowerCase().includes('admin fee')) {
            adminFeeItem = lineItem
          } else {
            priceItems.push({
              label:lineItem.type === 'invoiceitem' && lineItem.description != 'Shipping' ? lineItem.quantity + " x " + lineItem.description : lineItem.description,
              discounted_value: (calculateItemPrice(lineItem) / 100).toFixed(2),
              value: (lineItem.amount / 100).toFixed(2),
              class: 'text-sm',
              discounted:discounted
            })
          }
        }
      });
      // add shipping and admin fee at the end (shipping first, admin fee last)
      [shippingItem, adminFeeItem].filter(Boolean).forEach(item => {
        let discounted = (item.discount_amounts && item.discount_amounts.length);
        priceItems.push({
          label: item.type === 'invoiceitem' ? item.quantity + " x " + item.description : item.description,
          discounted_value: (calculateItemPrice(item) / 100).toFixed(2),
          value: (item.amount / 100).toFixed(2),
          class: 'text-sm',
          discounted: discounted
        })
      });

      // priceItems.push({
      //   label:'Subtotal',
      //   value: (invoice.subtotal / 100).toFixed(2),
      //   class: 'text-sm md:text-base lg:text-lg'
      // });
      if($shopData.coupon){
        priceItems.push({
          label:'Discounts',
          class:'discount',
          value: getCouponDetails()
        })
      }
      total = invoice.total / 100;

    }else {
      let price = data.payment_intent;
      let diff = 0;
      // this is only used, if the coupon applied is 100% off,
      // this means we have no price object and we can assume 0
      if(price.object === 'setup_intent'){
        total = 0;
        if($shopData.coupon){
          priceItems.push({
            label:"Sub total",
            value: (price.amount - (getDiscount(false) * ($shopData.productType === 'couple' ? 2 : 1)) / 100).toFixed(2)
          });
          priceItems.push({
            label:"Discount",
            class:'discount',
            value: (getDiscount(false) * ($shopData.productType === 'couple' ? 2 : 1) / 100).toFixed(2)
          })
        }
      }else{
        total = price.amount / 100;
        if($shopData.coupon){
          // if(product.slug == "oto-personal"){
            // priceItems.push({
            //   label:"Sub total",
            //   value: price.amount - (getDiscount(false) * ($shopData.productType === 'couple' ? 2 : 1)) / 100
            // })
          // }
          priceItems.push({
            label:"Sub total",
            value: (price.amount - (getDiscount(false) * ($shopData.productType === 'couple' ? 2 : 1)) / 100).toFixed(2)
          })
          priceItems.push({
            class:'discount',
            label:"Discount",
            value: (getDiscount(false) * ($shopData.productType === 'couple' ? 2 : 1) / 100).toFixed(2)
          });
        }else{
          priceItems.push({
            label:"Sub total",
            value: (price.amount / 100).toFixed(2)
          })
        }
      }
    }

    showTotal = true;
  }

  onDestroy(()=>{
    if(unsubscribe){
      unsubscribe()
    }
  })

  let unsubscribe = shopData.subscribe(data => {
  })

</script>
<style type="text/scss">
  img {
    width:60px;
    height:60px;
  }

  .price {
    font-weight: bold;
    @media screen and (min-width:1200px){
      font-size: 17px;
    }
    @media screen and (max-width:1200px){
      font-size: 15px;
    }
    @media screen and (max-width:999px){
      text-align: center;
    }
  }

  h1 {
    @media screen and (min-width:1200px){
      font-size: 24px;
      line-height: 26px;
    }
    @media screen and (max-width:1200px){
      font-size: 18px;
      line-height: 20px;
      margin-bottom: 10px;
    }
  }


  .item {
    align-items: baseline;
    .dots {
      border-bottom:1px dotted rgba(0,0,0,.5);
    }
  }

  .total {
    background: rgba(0,0,0,.4);
    color: white;
    border-radius: 5px;
    padding: 5px 10px;
    margin-top:10px;
  }

  :global(.item.discount){
    margin: 10px 0;
    background: white;
    color: #333;
    padding: 5px 10px;
    border-radius: 7px;
  }

  :global(.item.discounted .value){
    text-decoration: line-through;
    margin-right:3px;
  }

</style>

<div class="{$$props.class || ''} my-6 bg-gray-100 p-4 rounded-md">
  {#if !showTotal}
    <div class="price"><span class:line-through={$shopData.coupon?.valid && $shopData.coupon?.metadata?.type !== 'admin_fee'}>${productTotal.toFixed(2)}</span>
      {#if $shopData.coupon?.valid && $shopData.coupon?.metadata?.type !== 'admin_fee'}${(getDiscount() / 100).toFixed(2)}{/if}
      USD{price.type === "recurring" ? '/'+price.recurring.interval : ''} {$shopData.productType === 'couple' ? 'x 2' : ''} </div>
    {#if $shopData.coupon}
      <div class="discount"><i class="fa-duotone fa-tags mr-1"></i> Coupon Applied: {getCouponDetails()}</div>
    {/if}
  {/if}

  {#if showTotal}
  <div class="value">
    {#each priceItems  as lineItem, i}
    <div class="item flex {lineItem.class}" class:discounted={lineItem.discounted} >
      <strong class="mr-2 font-normal">{lineItem.label}</strong>
      <span class="flex-1 dots"></span>
      <span class="ml-2 value">${lineItem.value} </span>
      {#if lineItem.discounted}
      <span class="ml-2">${lineItem.discounted_value} *</span>
      {/if}
    </div>
    {/each}
    <div class="total item flex">
      <strong class='mr-2'>Total Due Today</strong>
      <span class="flex-1 dots"></span>
      <span class="ml-2 price">${total.toFixed(2)}</span>
    </div>
  </div>
  {#if showDiscountStar}
    <span class="text-xs">* Discounts were applied based on the packages you chose.</span>
  {/if}
  {/if}

</div>
